module.exports = "https://product-cdn.sandbox.surfline.com/kbyg/_next/static/images/app-store-badge-15f01eefb2013206cc7e26d98fbe95fb.svg";